module.exports = __webpack_public_path__ + "img/f_2.9674bceb.png";